class MainPromotions extends HTMLElement {
  constructor() {
    super();
    this.activeFilter = 'all';
    this.filterTimeout = null;
    this.cachedItems = null;
    this.init();
  }

  init() {
    const tabs = Array.from(this.querySelectorAll('.main-promotions__tab'));
    
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const filter = tab.getAttribute('data-filter');
        this.setActiveFilter(filter);
      });
    });

    // Apply filter to initial items
    this.applyFilter();

    // Watch for new items added via pagination
    this.observeNewItems();
  }

  setActiveFilter(filter) {
    if (this.activeFilter === filter) return;
    
    this.activeFilter = filter;
    const tabs = Array.from(this.querySelectorAll('.main-promotions__tab'));
    
    // Update active tab
    tabs.forEach(t => {
      if (t.getAttribute('data-filter') === filter) {
        t.classList.add('is-active');
      } else {
        t.classList.remove('is-active');
      }
    });
    
    // Invalidate cache when filter changes
    this.cachedItems = null;
    this.applyFilter();
  }

  getItems() {
    // Cache items to avoid repeated DOM queries
    if (!this.cachedItems) {
      this.cachedItems = Array.from(this.querySelectorAll('.main-promotions__item'));
    }
    return this.cachedItems;
  }

  applyFilter() {
    // Use requestAnimationFrame for better performance
    if (this.filterTimeout) {
      cancelAnimationFrame(this.filterTimeout);
    }

    this.filterTimeout = requestAnimationFrame(() => {
      const items = this.getItems();
      
      items.forEach(item => {
        const category = item.getAttribute('data-category');
        const isHidden = item.classList.contains('hidden');
        
        if (this.activeFilter === 'all') {
          if (isHidden) {
            item.classList.remove('hidden');
          }
        } else if (category && category.includes(this.activeFilter)) {
          if (isHidden) {
            item.classList.remove('hidden');
          }
        } else {
          if (!isHidden) {
            item.classList.add('hidden');
          }
        }
      });
    });
  }

  observeNewItems() {
    // Watch for changes in the list container (when new items are loaded via pagination)
    const listContainer = this.querySelector('.main-promotions__list');
    if (!listContainer) return;

    const observer = new MutationObserver((mutations) => {
      // Only process if items were actually added
      const hasAddedNodes = mutations.some(mutation => 
        mutation.addedNodes.length > 0 && 
        Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && node.classList?.contains('main-promotions__item')
        )
      );

      if (hasAddedNodes) {
        // Invalidate cache when new items are added
        this.cachedItems = null;
        // Debounce filter application
        this.applyFilter();
      }
    });

    observer.observe(listContainer, {
      childList: true,
      subtree: true
    });
  }
}

customElements.define('main-promotions', MainPromotions); 